import CartIcon from "../All Icons and Logos/CartIcon";

import ClickAndCollectIcon from "../GridRows(10-12)/AllTypesOfIcons/ClickAndCollectIcon";
import cart1 from "./2ndPage.1Images/cart1.jpg";
import cart2 from "./2ndPage.1Images/cart2.jpg";
import cart3 from "./2ndPage.1Images/cart3.jpg";
import cart4 from "./2ndPage.1Images/cart4.jpg";
import cart5 from "./2ndPage.1Images/cart5.jpg";
import cart1hover from "./2ndPage.1Images/cart1hover.jpg";
import cart2hover from "./2ndPage.1Images/cart2hover.jpg";
import cart3hover from "./2ndPage.1Images/cart3hover.jpg";
import cart4hover from "./2ndPage.1Images/cart4hover.jpg";
import cart5hover from "./2ndPage.1Images/cart5hover.jpg";
import r11 from "./2ndPage.1Images/2nd.1.jpg";
import r12 from "./2ndPage.1Images/2nd.2.jpg";
import r13 from "./2ndPage.1Images/2nd.3.jpg";
import JustOrderIcon from "./JustOrderIcon";
import CaretRightIconFor2ndPageDimension from "./CaretRightIconFor2ndPageDimension";
import CartIconForAddCartButton from "./CartIconForAddCartButton";
import "./GridRow2ndPage1(300-599px).css";
import "./GridRow2ndPage1(600-899px).css";
import "./GridRow2ndPage1.css";


import DimensionCancelIcon from "./DimensionCancelIcon";
import CartCancelIcon from "./CartCancelIcon";
import LikedBoxCancelIcon from "../GridRows(7-9)/CaretLeftAndRight/LikedBoxCancelIcon";

const GridRow2ndPage1 = () => {
  function DimensionBoxHandler() {
    document.getElementById("DimensionBoxId").classList.add("DimensionBoxShow");
    document.getElementById("BackDrop").classList.add("menuBackDropHandler");
  }

  function CartConfirmBoxHandler() {
    document.getElementById("CartBoxId").classList.add("CartBoxShow");
    document.getElementById("BackDrop").classList.add("menuBackDropHandler");
  }
  return (
    <>
      <div className="GridBox2ndPage-1Real">
        <div className="GridBox2ndPage-1">
          <div className="GridBox2ndPage-1-Images">
            <img src={r11} className="r11"></img>
            <img src={r12} className="r12"></img>
            <img src={r13} className="r13"></img>
            <div className="descriptionAboutProducts">
              This easy-care mattress protector prevents stains on your mattress
              and adds a layer of soft comfort. It gives a perfectly smooth
              finish to your mattress and stays in place thanks to the elastic
              straps.
              <p> Delivery and assembly prices not included.</p>
              <p> Article number.</p>
              <button className="ArticleButton">004.619.92</button>
            </div>
          </div>
        </div>
        <div className="cartBox">
          <div className="ProductMainDetail">
            <p className="ProductTitle">ÄNGSKORN</p>
            <p className="ProductPrice">
              Rs.<span>1,790</span>
            </p>
          </div>
          <div className="OriginalTranslationWithDimen">
            <p className="OriginalTranslation">Mattress protector ,</p>
            <br></br>
            <p className="dimensions">180x200 cm (71x79 ")</p>
          </div>
          <p className="PriceWithTax">Price incl. of all taxes</p>
          <p className="ratingStar">
            <span>* * * * *</span>(5)
          </p>
          <div className="borderline"></div>
          <div className="inwardArrowBox" onClick={DimensionBoxHandler}>
            <div>
              <span>
                <b>Choose size</b>
              </span>
              <p> 180x200 cm </p>
            </div>
            <CaretRightIconFor2ndPageDimension />
          </div>
          <p className="OptionsToGet">
            <b>How to get it</b>
          </p>
          <div className="cartinsideBox">
            <div className="cartinsideBoxIcon">
              <ClickAndCollectIcon />
            </div>
            <div>
              <p>
                <b>In store</b>
              </p>
              <a href="">
                <p>Check in-store stock </p>
              </a>
            </div>
          </div>
          <input className="Pincode" placeholder="Enter pincode"></input>
          <button className="CheckInButton">Check</button>
          <div className="justOrderIcon">
            <JustOrderIcon />
            <p>Please enter pin code to check home delivery availability.</p>
          </div>
          <button className="AddToCartButton" onClick={CartConfirmBoxHandler}>
            <div className="AddToCartButtonIcon">
              <CartIconForAddCartButton />
            </div>
            Add to cart
          </button>
          <div className="NoteBox">
            <div>
              <p style={{ color: "black" }}>
                <b>Made in India</b>
              </p>
              <p>
                Designed by IKEA of Sweden. Bringing quality, design, and
                affordability together.
              </p>
            </div>
          </div>
        </div>
        <div className="descriptionAboutProducts2">
          This easy-care mattress protector prevents stains on your mattress and
          adds a layer of soft comfort. It gives a perfectly smooth finish to
          your mattress and stays in place thanks to the elastic straps.
          <p> Delivery and assembly prices not included.</p>
          <p> Article number.</p>
          <button className="ArticleButton">004.619.92</button>
        </div>
      </div>
      <div id="DimensionBoxId" className="DimensionBoxHide">
        <div>
          {" "}
          <DimensionCancelIcon />
        </div>
        <div className="DimensionBoxHeading">
          <p>Choose size</p>
        </div>
        <div className="DBox1">
          <p>80x200 cm</p>
          <p> </p>
        </div>
        <div className="DBox2">
          <p>90x200 cm</p>
          <p>+ Rs.191</p>
        </div>
        <div className="DBox3">
          <p>140x200 cm</p>
          <p>+ Rs.791</p>
        </div>
        <div className="DBox4">
          <p>160x200 cm</p>
          <p>+ Rs.991</p>
        </div>
        <div className="DBox5">
          <p>180x200 cm</p>
          <p>+ Rs.791</p>
        </div>
      </div>

      <div id="CartBoxId" className="CartBoxHide">
        <div className="CartCancelIconContainer">
          {" "}
          <CartCancelIcon />
        </div>
        <div className="CartBoxHeading">
          <p>ÄNGSKORN was added to your shopping bag </p>
          <p>
            <a href="">Continue to bag</a>
          </p>
        </div>

        <div className="CartContentHeading">Related products</div>
        <div className="OtherProductContent">
          <div className="cart1">
            <img src={cart1}></img>
            <img src={cart1hover} className="cart1hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">DVALA</p>
            <p className="CartOtherProductDimensions">
              Fitted sheet, 180x200 cm (71x79 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>799</span>
            </p>
            <p className="OtherProductsStarRating">* * * * * 
            <span>(27)</span></p>
            <p>More options</p>
          </div>
        </div>

        <div className="OtherProductContent">
          <div className="cart2">
            <img src={cart2}></img>
            <img src={cart2hover} className="cart2hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">ÄNGSKORN</p>
            <p className="CartOtherProductDimensions">
              Mattress protector, 160x200 cm (63x79 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,790</span>
            </p>
            <p className="OtherProductsStarRating">* * * * *
            <span>(5)</span></p>
            <p>More options</p>
          </div>
        </div>

        <div className="OtherProductContent">
          <div className="cart3">
            <img src={cart3}></img>
            <img src={cart3hover} className="cart3hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">NATTJASMIN</p>
            <p className="CartOtherProductDimensions">
              Fitted sheet, 180x200 cm (71x79 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,790</span>
            </p>
            <p className="OtherProductsStarRating">* * * * *
            <span>(9)</span></p>
            <p>More options</p>
          </div>
        </div>
        {/* <div className="OtherProductContent">
          <div className="cart4">
            <img src={cart4}></img>
            <img src={cart4hover} className="cart4hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">ROSENSKÄRM</p>
            <p className="CartCartCartCartOtherProductDimensions">
              Ergonomic pillow, side/back sleeper, 33x50 cm (13x20 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,990</span>
            </p>
            <p>* * * * *</p>
            <span>(22)</span>
          </div>
        </div> */}
        <div className="OtherProductContent">
          <div className="cart4">
            <img src={cart4}></img>
            <img src={cart4hover} className="cart4hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">NATTJASMIN</p>
            <p className="CartOtherProductDimensions">
              Fitted sheet, 180x200 cm (71x79 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,790</span>
            </p>
            <p className="OtherProductsStarRating">* * * * *
            <span>(22)</span></p>
            <p>More options</p>
          </div>
        </div>

        <div className="OtherProductContent">
          <div className="cart5">
            <img src={cart5}></img>
            <img src={cart5hover} className="cart5hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">SKOGSFRÄKEN</p>
            <p className="CartOtherProductDimensions">
              Pillow, high, 50x80 cm (20x32 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,090</span>
            </p>
            <p className="OtherProductsStarRating">* * * * *
            <span>(9)</span></p>
          </div>
        </div>

        <div className="OtherProductContent">
          <div className="cart1">
            <img src={cart1}></img>
            <img src={cart1hover} className="cart1hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">DVALA</p>
            <p className="CartOtherProductDimensions">
              Fitted sheet, 180x200 cm (71x79 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>799</span>
            </p>
            <p className="OtherProductsStarRating">* * * * * 
            <span>(27)</span></p>
            <p>More options</p>
          </div>
        </div>

        <div className="OtherProductContent">
          <div className="cart2">
            <img src={cart2}></img>
            <img src={cart2hover} className="cart2hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">ÄNGSKORN</p>
            <p className="CartOtherProductDimensions">
              Mattress protector, 160x200 cm (63x79 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,790</span>
            </p>
            <p className="OtherProductsStarRating">* * * * *
            <span>(5)</span></p>
            <p>More options</p>
          </div>
        </div>

        <div className="OtherProductContent">
          <div className="cart3">
            <img src={cart3}></img>
            <img src={cart3hover} className="cart3hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">NATTJASMIN</p>
            <p className="CartOtherProductDimensions">
              Fitted sheet, 180x200 cm (71x79 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,790</span>
            </p>
            <p className="OtherProductsStarRating">* * * * *
            <span>(9)</span></p>
            <p>More options</p>
          </div>
        </div>
        {/* <div className="OtherProductContent">
          <div className="cart4">
            <img src={cart4}></img>
            <img src={cart4hover} className="cart4hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">ROSENSKÄRM</p>
            <p className="CartCartCartOtherProductDimensions">
              Ergonomic pillow, side/back sleeper, 33x50 cm (13x20 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,990</span>
            </p>
            <p>* * * * *</p>
            <span>(22)</span>
          </div>
        </div> */}
        <div className="OtherProductContent">
          <div className="cart4">
            <img src={cart4}></img>
            <img src={cart4hover} className="cart4hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">NATTJASMIN</p>
            <p className="CartOtherProductDimensions">
              Fitted sheet, 180x200 cm (71x79 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,790</span>
            </p>
            <p className="OtherProductsStarRating">* * * * *
            <span>(22)</span></p>
            <p>More options</p>
          </div>
        </div>

        <div className="OtherProductContent">
          <div className="cart5">
            <img src={cart5}></img>
            <img src={cart5hover} className="cart5hover"></img>
          </div>
          <div>
            <p className="OtherProductHeading">SKOGSFRÄKEN</p>
            <p className="CartOtherProductDimensions">
              Pillow, high, 50x80 cm (20x32 ")
            </p>
            <p className="OtherProductPrice">
              Rs.<span>1,090</span>
            </p>
            <p className="OtherProductsStarRating">* * * * *
            <span>(9)</span></p>
          </div>
        </div>
      </div>


      
      <div id="LikedBoxId" className="HideLikedBox">
        <p id="LikedBoxLineId" className="LikedBoxLine">
          {" "}
        </p>
        <a className="LikedBoxLink" href="#">
          show
        </a>
        <div className="LikedBoxCancelIcon">
          <LikedBoxCancelIcon />
        </div>
      </div>
    </>
  );
};
export default GridRow2ndPage1;
